"use client"

import { type SelectionQueryParams } from "@/lib/centra-client/interfaces/ISelectionService"
import logger from "@/lib/logger/logger-init"
import { type CheckoutAPISelectionWithRequiredToken } from "@/types/centra/checkout-api/selection/get-selection"
import { type Result, ResultFactory } from "@/types/generic/Result"

type AddVoucherFunction = (
    params: SelectionQueryParams
) => Promise<Result<CheckoutAPISelectionWithRequiredToken>>

export const addVoucher: AddVoucherFunction = async params => {
    try {
        const response = await fetch("/api/centra/add-voucher", {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(params)
        })

        const result = await response.json()

        if (!response.ok || !result.success) {
            const errorMessage = result.error || "Failed to apply voucher"
            logger.error(errorMessage)
            return ResultFactory.failure<CheckoutAPISelectionWithRequiredToken>(
                new Error(errorMessage)
            )
        }

        logger.info("Voucher processing succeeded", { data: result.data })
        return ResultFactory.success<CheckoutAPISelectionWithRequiredToken>(result.data)
    } catch (error) {
        logger.error("Unexpected error in addVoucher", error)
        return ResultFactory.failure<CheckoutAPISelectionWithRequiredToken>(
            error instanceof Error ? error : new Error("Failed to apply voucher")
        )
    }
}
